import styles from './Header.module.scss';
import { Col, Container, Row } from 'react-grid-system';
import Image from 'next/image';
import { IconWhats, Text } from 'condolivre-ds';
import React from 'react';

export const Header = () => {
    return (
        <Container className={styles.header}>
            <Row>
                <Col lg={6} className={[styles.left, styles.logo].join(' ')}>
                    <Image src="/images/Logo_condolivre_pos.png" width="200" height="52" />
                </Col>
                <Col lg={6} className={styles.right}>
                    <Text weight="v_500" color="gray_800" size="v_16">
                        Precisa de ajuda?
                    </Text>
                    <Text
                        family="regular"
                        size="v_20"
                        color="blue_900"
                        weight="v_600"
                        className={styles.tip}>
                        <IconWhats />
                        <span>(11) 998084-1487</span>
                    </Text>
                </Col>
            </Row>
        </Container>
    );
};
